import { STATUS_PERSIST, ACTION_PERSIST } from "./constants";

export const persist = (payload, type) => ({
    type,
    payload,
    status: STATUS_PERSIST,
});

export default {
    persist,
};
